import React, { createContext, useContext } from 'react'

// Create midfeed ads context
const MidFeedAdsContext = createContext()

// Create midfeed ads provider
// This provider will be used to pass the ads to the midfeed component
const MidFeedAdsProvider = ({ midFeedAds = [], children }) => (
  <MidFeedAdsContext.Provider value={midFeedAds}>
    {children}
  </MidFeedAdsContext.Provider>
)

const useMidFeedAds = () => {
  return useContext(MidFeedAdsContext)
}
export { MidFeedAdsProvider, useMidFeedAds }
